import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import CoverageReportTable from "../coverage-report-table"
import CoverageReportSecurities from "../coverage-report-securities"

function CoverageReport({
  securities,
  securitiesPage,
  showSecuritiesPage,
  coverage,
  coveragePage,
  showCoveragePage,
  numberOfTableRows,
  model,
  showDate,
  coverageDate,
  resetDate,
  downloadButton,
  type,
}) {
  return <div className="coverage-report">
    <Paper elevation={1} square>
      {coverageDate
        ? <CoverageReportSecurities
            securities={securities}
            coverageDate={coverageDate}
            securitiesPage={securitiesPage}
            showSecuritiesPage={showSecuritiesPage}
            numberOfTableRows={numberOfTableRows}
            resetDate={resetDate}
            type={type}
        />
        : <CoverageReportTable
            coverage={coverage}
            coveragePage={coveragePage}
            showCoveragePage={showCoveragePage}
            numberOfTableRows={numberOfTableRows}
            model={model}
            showDate={showDate}
            downloadButton={downloadButton}
        />}
    </Paper>
  </div>
}

CoverageReport.propTypes = {
  securities: PropTypes.object.isRequired,
  securitiesPage: PropTypes.number.isRequired,
  showSecuritiesPage: PropTypes.func.isRequired,
  numberOfTableRows: PropTypes.number.isRequired,
  coverageDate: PropTypes.string,
  resetDate: PropTypes.func.isRequired,
  coverage: PropTypes.object.isRequired,
  coveragePage: PropTypes.number.isRequired,
  showCoveragePage: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  showDate: PropTypes.func.isRequired,
  downloadButton: PropTypes.element.isRequired,
  type: PropTypes.string.isRequired,
}

export default CoverageReport
